var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegramFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.58583 11.3691C7.95453 9.03021 11.5345 7.48828 13.3258 6.74329C18.4401 4.6162 19.5028 4.24671 20.1955 4.23451C20.3479 4.23182 20.6885 4.26957 20.9091 4.4486C21.0955 4.59977 21.1467 4.80398 21.1713 4.9473C21.1958 5.09062 21.2263 5.41712 21.202 5.67223C20.9249 8.58405 19.7257 15.6503 19.1156 18.9116C18.8574 20.2915 18.3491 20.7542 17.857 20.7995C16.7875 20.8979 15.9754 20.0928 14.9396 19.4138C13.3187 18.3514 12.4031 17.6901 10.8297 16.6533C9.01147 15.4552 10.1902 14.7967 11.2264 13.7205C11.4976 13.4389 16.2097 9.15322 16.3009 8.76444C16.3123 8.71581 16.3228 8.53457 16.2152 8.43887C16.1075 8.34316 15.9486 8.37589 15.8339 8.40192C15.6713 8.43881 13.0819 10.1502 8.0658 13.5359C7.33082 14.0406 6.6651 14.2865 6.06864 14.2736C5.41108 14.2594 4.14621 13.9018 3.20591 13.5962C2.0526 13.2213 1.13596 13.0231 1.21578 12.3865C1.25736 12.0549 1.71404 11.7158 2.58583 11.3691Z",
    fill: "black",
    fillOpacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramFill);
export default __webpack_public_path__ + "static/media/telegram-fill.d35b4e1d3caa0d5726dd4b9b7a4b1f67.svg";
export { ForwardRef as ReactComponent };